import { DeliveryType } from "@omni/types/api/product/bff/shared/enums/deliveryType.enum";

import { StorePickerModal } from "@/components/Store/StorePicker/storePickerModal.container";
import { StorePickerFeature } from "@/components/Store/StorePicker/types/storePickerFeature.enum";
import { StorePickerFilter } from "@/components/Store/StorePicker/types/storePickerFilter.enum";
import { StorePickerType } from "@/components/Store/StorePicker/types/storePickerType.enum";
import { GetStoreStrategy } from "@/services/store.service";
import { StorePickerModalStates } from "@/utils/enums";
import { useStore } from "@/utils/hooks/store/useStore.hook";

import { useECommerceContext } from "../../context/eCommerce.context";
import { useStorePickerModalContext } from "../../context/storePickerModal.context";
import { useECommerceProduct } from "../../hooks/useECommerceProduct.hook";
import { useProductDetail } from "../../hooks/useProductDetail.hook";

const StorePickerInfoComponent = () => {
    const { storePickerType, storePickerModalState, setStorePickerModalState } =
        useStorePickerModalContext();
    const { isEcommerceReady, infoLink } = useECommerceContext();
    const { isBoxArticle, sku } = useECommerceProduct();
    const { deliveryType } = useProductDetail();

    const { store } = useStore({
        strategy: GetStoreStrategy.Session,
        sku: sku
    });

    return (
        <>
            {isEcommerceReady && storePickerType === StorePickerType.INFO && (
                <StorePickerModal
                    isOpen={
                        storePickerModalState !== StorePickerModalStates.Closed
                    }
                    type={StorePickerType.INFO}
                    displayStockLevel={!isBoxArticle}
                    initialActiveFilters={[
                        StorePickerFilter.FILTER_EMPTY_STOCK
                    ]}
                    infoLink={infoLink}
                    storeCode={store?.code ?? null}
                    fixedFeatures={
                        deliveryType === DeliveryType.ClickAndCollect
                            ? [StorePickerFeature.BUY_ONLINE_PICKUP_IN_STORE]
                            : []
                    }
                    onClose={() =>
                        setStorePickerModalState(StorePickerModalStates.Closed)
                    }
                />
            )}
        </>
    );
};

export { StorePickerInfoComponent };
